import { render } from "./PopoverEditVehicle.vue?vue&type=template&id=d431e4e2"
import script from "./PopoverEditVehicle.vue?vue&type=script&lang=js"
export * from "./PopoverEditVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script